import { Modal, Spin } from "antd";
import {
  CheckCircleOutlined,
  CloseCircleOutlined,
  InfoCircleOutlined,
} from "@ant-design/icons";

const iconTypes = {
  success: {
    icon: <CheckCircleOutlined style={{ fontSize: 60, color: "#52c41a" }} />,
    bgColor: "#F6FFED",
  },
  error: {
    icon: <CloseCircleOutlined style={{ fontSize: 60, color: "#ff4d4f" }} />,
    bgColor: "#FFF2F0",
  },
  info: {
    icon: <InfoCircleOutlined style={{ fontSize: 60, color: "#1677ff" }} />,
    bgColor: "#E6F4FF",
  },
};

const ModalInfo = ({
  open,
  onClose,
  title,
  mensaje,
  type = "info",   
  loading = false,  
  footerButtons,
}) => {
  const { icon, bgColor } = iconTypes[type] || iconTypes.info;

  return (
    <Modal
      open={open}
      onCancel={onClose}
      centered
      footer={footerButtons || null}
      style={{
        borderRadius: 20,
        padding: 0,
      }}
      bodyStyle={{
        backgroundColor: bgColor,
        borderRadius: 20,
        padding: "30px 20px",
        textAlign: "center",
        fontFamily: "Manrope",
      }}
    >
      {/* Icono o spinner */}
      <div style={{ marginBottom: 20 }}>
        {loading ? (
          <Spin size="large" />
        ) : (
          icon
        )}
      </div>

      {/* Título */}
      <h2
        style={{
          marginBottom: 10,
          color: "#021442",
          fontWeight: 700,
        }}
      >
        {title}
      </h2>

      <p
        style={{
          color: "#021442",
          marginBottom: 0,
          whiteSpace: "pre-line",
        }}
      >
        {mensaje}
      </p>
    </Modal>
  );
};

export default ModalInfo;
